import actions from '../../actionTypes';

export default workflow => {
  return {
    type: actions.REMOVE_WORKFLOW,
    workflow
  };
};



// WEBPACK FOOTER //
// ./src/reducers/workflows/actions/removeWorkflow.js